<label class="switch">
  <input type="checkbox" [formControl]="control">
  <span class="slider round"></span>
</label>